/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBallTennis = createReactComponent("ball-tennis", "IconBallTennis", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M6 5.3a9 9 0 0 1 0 13.4", key: "svg-1" }],
  ["path", { d: "M18 5.3a9 9 0 0 0 0 13.4", key: "svg-2" }]
]);

export { IconBallTennis as default };
//# sourceMappingURL=IconBallTennis.js.map
